import ReferencesModal from '@components/referencesModal';
import { observer } from 'mobx-react';

export const Modals = observer(() => (
  <>
    <ReferencesModal />
  </>
));
